import { useField, useFormikContext } from 'formik';
import { SearchableMenuMultiSelectList, SearchableMenuProvider, SearchableMenuSearchHeader, SearchableMenuBody, useSearchableMenuFuse, } from 'shared/domains/common-ui/SearchableMenu';
import { NewValue } from './NewValue';
import { useGetPropertyValues } from './useGetPropertyValues';
export function MultiSelectWithInput(props) {
    const { name } = props;
    const { submitForm } = useFormikContext();
    const [field, , helpers] = useField({
        name: 'value',
    });
    const { data } = useGetPropertyValues(name, field.value);
    const searchableItems = data.map((value) => ({ id: value }));
    const selected = Array.isArray(field.value) ? field.value : [];
    const search = useSearchableMenuFuse(searchableItems, {
        keys: ['id'],
        threshold: 0,
    });
    const handleSelectItem = (item) => {
        const isSelected = selected.includes(item);
        if (isSelected) {
            helpers.setValue(selected.filter((value) => value !== item));
        }
        else {
            helpers.setValue([...selected, item]);
        }
        submitForm();
    };
    return (<SearchableMenuProvider {...search}>
      <SearchableMenuSearchHeader />
      <SearchableMenuBody>
        <SearchableMenuMultiSelectList emptyComponent={<NewValue addItem={handleSelectItem}/>} onSelect={(item) => handleSelectItem(item.id)} renderItem={({ id }) => id} selected={selected}/>
      </SearchableMenuBody>
    </SearchableMenuProvider>);
}
